module.exports = __webpack_public_path__ + "img/selected_mobile.6f3c51f2.png";